export default __webpack_public_path__ + "static/media/potato.03fcb39d.jfif";